import { useAppStore } from '@40seas/frontend/dashboard/contexts';
import { Route, Routes } from 'react-router-dom';
import { useSendDashboardViewPage } from '../../hooks/useDashboardEventTracker/useDashboardEventTracker';
import { Admin } from './Admin';
import { OAuthCallback } from '../auth/OAuthCallback';

export const AdminRouter = () => {
    const { basename } = useAppStore();

    useSendDashboardViewPage();

    return (
        <Routes>
            <Route path="/auth/callback" element={<OAuthCallback />} />
            <Route path={`${basename}/*`} element={<Admin />}></Route>
            <Route path={`*`} element={<Admin />}></Route>
        </Routes>
    );
};
